import React, { Component } from 'react';
import PanelView from '../../model/PanelView.js';
import moment from 'moment';
import {Glyphicon} from 'react-bootstrap';
import {clone, getLeaderName} from '../../util/Utility.js';

export default class AnnouncementPanelView extends Component {

  constructor(props) {
    super(props);

    this.defaultState = {
      object: null,
    };

    this.state = {
      object: clone(props.objectPass),
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps != this.props) {
      this.state = clone(this.defaultState);
      this.setState({object: clone(newProps.objectPass)});
    }
  }

  render() {

    var object = this.state.object;


    return (
      <PanelView type="announcement" edit delete setState={this.setState.bind(this)} object={object} {...this.props}>
        <div>
          <center>
            <h2 style={{margin: 0}}>{object.title}</h2>
            <p className="popoverTextHeader">Posted on {moment.unix(parseInt(object.date)).format("MMMM Do, YYYY @ h:mm A")}</p>
            <p className="popoverTextHeader">Expires in {moment().diff(moment.unix(object.expires), 'd') * -1 + 1} days</p>
            <div style={{height: 7}} />
            <p style={{textAlign: 'left'}}>{object.content}</p>
          </center>
          {object.approval2 ? <p><Glyphicon glyph="ok" /> Approved By {getLeaderName(object.approval2)}</p> : (object.ministryID === 'cco' ? <p><Glyphicon glyph="time" /> Waiting on Validity Approval</p> : null)}
          {object.show ? <p><Glyphicon glyph="ok" /> Showing in the app</p> : <p><Glyphicon glyph="remove" /> Not showing in the app</p>}
        </div>
      </PanelView>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/ministry/announcements/AnnouncementPanelView.js
 **/